// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    color: var(--color-text);
    background-color: var(--color-bg-3);
    border-radius: 3px;
    padding: 3px 7px;
    height: 29px;
    box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/Badge/s.badge.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,wBAAwB;IACxB,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;AAC1B","sourcesContent":[".badge {\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n    color: var(--color-text);\n    background-color: var(--color-bg-3);\n    border-radius: 3px;\n    padding: 3px 7px;\n    height: 29px;\n    box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
